import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin')({
  head: () => ({
    meta: [
      { title: 'Admin Dashboard | Calvarius' },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  }),
  beforeLoad: async ({ location }) => {
    // Skip during SSR — session lives in browser storage only
    if (typeof window === 'undefined') return;
    // Allow the login route through
    if (location.pathname === '/admin/login') return;
    // Dynamic import keeps the Supabase tree out of the main bundle.
    const { supabase } = await import('@/integrations/supabase/client');
    const { data } = await supabase.auth.getSession();
    if (!data.session) {
      throw redirect({ to: '/admin/login' });
    }
    const { data: roleRow } = await supabase
      .from('user_roles')
      .select('role')
      .eq('user_id', data.session.user.id)
      .eq('role', 'admin')
      .maybeSingle();
    if (!roleRow) {
      throw redirect({ to: '/admin/login' });
    }
  },
});
